module.exports = "/_next/static/images/ea869cafe00023dd6cc2a294eb8819cf-icon-2.svg";